import React from 'react';
import { Route, Switch } from 'react-router';
// components
// import asyncComponent from './components/AsyncComponent';
import App from './containers/App/App';
import Home from './containers/Home/Home';

// Semi Static
import About from './containers/About/About';
import Resources from './containers/Resources/Resources';
import DesignationSearch from './containers/DesignationSearch/DesignationSearch';
import NotFound from './containers/NotFound/NotFound';
import MortgageCalculator from './containers/MortgageCalculator/MortgageCalculator';
import Demographics from './containers/Demographics/Demographics';
import WhyUseRealtor from './containers/WhyUseRealtor/WhyUseRealtor';
import DMCA from './containers/DMCA/DMCA';
import PrivacyPolicy from './containers/PrivacyPolicy/PrivacyPolicy';
import TermsOfUse from './containers/TermsOfUse/TermsOfUse';
import AssistedLivingSearch from './containers/AssistedLivingSearch/AssistedLivingSearch';
import AssistedLivingDetail from './containers/AssistedLivingDetail/AssistedLivingDetail';
import POISearch from './containers/POISearch/POISearch';
import POIDetail from './containers/POIDetail/POIDetail';
import CommunitySearch from './containers/CommunitySearch/CommunitySearch';
import CommunityDetail from './containers/CommunityDetail/CommunityDetail';
import GolfCourseSearch from './containers/GolfCourseSearch/GolfCourseSearch';
import GolfCourseDetail from './containers/GolfCourseDetail/GolfCourseDetail';
import PropertySearch from './containers/PropertySearch/PropertySearch';
import PropertyDetail from './containers/PropertyDetail/PropertyDetail';
import AgentSearch from './containers/AgentSearch/AgentSearch';
import AgentDetail from './containers/AgentDetail/AgentDetail';
import OfficeSearch from './containers/OfficeSearch/OfficeSearch';
import OfficeDetail from './containers/OfficeDetail/OfficeDetail';
import ContactUs from './containers/ContactUs/ContactUs';
import FavoriteSearch from './containers/FavoriteSearch/FavoriteSearch';
import RealEstateNews from './containers/RealEstateNews/RealEstateNews';
import BlogContainer from './containers/Blog/Blog';
import BlogItemContainer from './containers/Blog/BlogItem';
// async components
// const MortgageCalculator = asyncComponent(() =>
//   import('./containers/MortgageCalculator/MortgageCalculator')
// );

const Routes = props => (
  <App>
    <Switch>
      <Route exact path="/" component={Home} />
      <Route path="/find-naples-home" component={PropertySearch} />
      <Route path="/find-naples-agent" component={AgentSearch} />
      <Route path="/property-detail/:id" component={PropertyDetail} />
      <Route path="/agent/:id" component={AgentDetail} />
      <Route path="/designations" component={DesignationSearch} />
      <Route path="/resources" component={Resources} />
      <Route path="/about" component={About} />
      <Route path="/mortgage-calculator" component={MortgageCalculator} />
      <Route path="/naples-collier-demographics" component={Demographics} />
      <Route path="/why-use-realtor" component={WhyUseRealtor} />
      <Route path="/dmca-policy" component={DMCA} />
      <Route path="/privacy-policy" component={PrivacyPolicy} />
      <Route path="/terms-of-use" component={TermsOfUse} />
      <Route path="/assisted-living" exact component={AssistedLivingSearch} />
      <Route path="/assisted-living/:id" component={AssistedLivingDetail} />
      <Route path="/find-poi" component={POISearch} />
      <Route path="/poi/:id" component={POIDetail} />
      <Route path="/find-community" component={CommunitySearch} />
      <Route path="/community/:id" component={CommunityDetail} />
      <Route path="/find-golf-course" component={GolfCourseSearch} />
      <Route path="/golf-course/:id" component={GolfCourseDetail} />
      <Route path="/find-naples-firm" component={OfficeSearch} />
      <Route path="/firm/:id" component={OfficeDetail} />
      <Route path="/contact-us" component={ContactUs} />
      <Route path="/favorites" component={FavoriteSearch} />
      <Route path="/real-estate-news" component={RealEstateNews} />
      <Route path="/blog/:id" component={BlogItemContainer} />
      <Route path="/blog" component={BlogContainer} />
      <Route component={NotFound} />
    </Switch>
  </App>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js